import { gup } from "./utils/utils";
import * as C from "./actionTypes";

const INITIAL_STATE = {
    boxHash1: gup('hash1'),
    boxHash2: gup('hash2'),
    userHash1: gup('uh1'),
    userHash2: gup('uh2'),
    tokenGiven: gup('token'),
    sendEmail: 0,
    listFiles: [],
    files: [],
    depositInformations: [],
    toaster: [],
    loadPercent: 0,
    removeClickable: false,
    isSent: false,
    readyToSend: false,
    almostReady: false,
    fileToUpload: {},
    valueSelect: "plusRecent"
}

export function depositReducer(state = INITIAL_STATE, action) {
    switch(action.type) {
        case C.ON_DROP:
            return { ...state, files: action.files }
        case C.SET_INFORMATIONS:
            return { ...state, depositInformations: action.depositInformations}
        case C.SET_TOASTER:
            return { ...state, toaster: action.toasterInfo }
        case C.REMOVE_TOASTER:
            return { ...state, toaster: "" }
        case C.SET_LOAD_PERCENT:
            return { ...state, loadPercent: action.percent }
        case C.REMOVE_BUTTON:
            return { ...state, removeClickable: action.check }
        case C.REMOVE_FILE_FROM_LIST:
            return { ...state, files: [...state.files.slice(0, action.index), ...state.files.slice(action.index + 1)]}
        case C.REMOVE_FILE_FROM_UPLOADS_LIST:
            return { ...state, files: [...state.files.filter(file => !action.fileIds?.includes(file?.id))]}
        case C.RESET_ALL_PROPS:
            return {...state, files: [], toaster: [], loadPercent: 0, isSent: false}
        case C.CHECK_IF_SENT:
            return {...state, isSent: action.check}
        case C.SET_LIST_FILES:
            return {...state, listFiles: action.files}
        case C.READY_TO_SEND:
            return {...state, readyToSend: true}
        case C.SET_READY_TO_SEND:
            return {...state, readyToSend: action.check}
        case C.SET_ALMOST_READY:
            return {...state, almostReady: action.check}
        case C.SET_VALUE_SELECT:
            return {...state, valueSelect: action.value}
        default:
            return state
    }
}
